<template>
  <el-select
    ref="selectTree"
    v-model="regionId"
    placeholder="选择地区"
    filterable
    clearable
    @clear="clearHandle"
  >
    <el-option :key="regionId" :label="regionName" :value="regionId" hidden>
    </el-option>
    <el-tree
      :data="regionList"
      :props="defaultProps"
      node-key="defaultProps.value"
      @node-click="handleNodeClick"
    ></el-tree>
  </el-select>
</template>
<script>
import { regionList } from "../utils/utilData";

export default {
  name: "RegionSelect",

  data() {
    return {
      regionList: [],
      regionId: "",
      regionName: "",
      defaultProps: {
        children: "children",
        label: "regionName",
        value: "regionId",
      },
    };
  },
  watch: {
    regionId(newVal, oldVal) {
      this.$emit("regionId", this.regionId);
    },
  },
  created() {
    this.regionList = regionList;
  },
  methods: {
    handleNodeClick(data) {
      this.regionId = data.regionId;
      this.regionName = data.regionName;
      this.$refs.selectTree.blur();
    },
    clearHandle() {
      this.regionId = "";
      this.regionName = "";
    },
    acceptId(regionId) {
      this.regionId = regionId;
      this.regionName = this.getRegionNameFromList(regionId, this.regionList);
    },
    // 根据regionId从regionList中返回regionName
    getRegionNameFromList2(regionId, regionList) {
      for (let i = 0, len = regionList.length; i < len; i++) {
        if (regionList.length <= 0) {
          return;
        }
        if (regionList[i].regionId == regionId) {
          return regionList[i].regionName;
        }
        return this.getRegionNameFromList(regionId, regionList[i].children);
      }
    },
    getRegionNameFromList(regionId, regionList) {
      if (regionList == null || regionList.length == 0) {
        return;
      }
      for (let i = 0, len = regionList.length; i < len; i++) {
        if (regionList[i].regionId == regionId) {
          return regionList[i].regionName;
        }
      }
      for (let i = 0, len = regionList.length; i < len; i++) {
        return this.getRegionNameFromList(regionId, regionList[i].children);
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>